import { useEffect, useState } from "react";
import { CommonService } from "../../../../services/CommonService";
import { useAdvanceSearchContext } from "../AdvanceSearchContext";
import { translateAndSortAscendant } from "../../../../common/helper";
import { DropDownMultiCheck } from "../DropDownMultiCheck";
import Icontrash from "../../../../layout/others/icon_delete.svg";

export default function Language() {
  const { searchObject, setSearchObject, onChange, t, errors } = useAdvanceSearchContext();
  const [languages, setLanguages] = useState([]);
  const [languageLevels, setLanguageLevels] = useState([]);

  useEffect(() => {
    CommonService.getAllLanguageLevels().then((data) =>
      {
        data.push({id:0 , description: t("N1 - Native")});
        setLanguageLevels(translateAndSortAscendant (data, "description"));
      }
    );
    CommonService.getAllLanguages().then((data) => setLanguages(translateAndSortAscendant (data, "description")));
  }, []);

  function setSelectedLanguageLevel(list) {
    let newOrderedList = languageLevels.indexOf(list[0]);
    if(newOrderedList > -1){
      list = languageLevels.slice(newOrderedList);
    }
    setSearchObject({ ...searchObject, languageLevels: list });
  }

  function clearLanguageLevel() {
    let _searchObject = { ...searchObject };
    _searchObject.languageLevels.length = 0;

    setSearchObject(_searchObject);
  }

  return (
    <fieldset>
      <legend>{t("Language")}</legend>
      <div className="col mb-2">
        <label className="form-label">{t("Language")}</label>{" "}
        {errors.languageId && (
          <span className="error-msg">{errors.languageId}</span>
        )}
        <select
          className="form-select"
          name="languageId"
          onChange={onChange}
          value={searchObject.languageId || ""}
        >
          <option value=""></option>
          {languages.map((language) => (
            <option key={language.id} value={language.id}>
              {t(language.description)}
            </option>
          ))}
        </select>
      </div>
      <div className="col" style={{marginTop:"20px"}}>
        <label className="form-label">{t("Level")}</label>{" "}
        <button
          onClick={clearLanguageLevel}
          className="app-button btn-second btn-md btn-clear-lang-level-old-advance-search btn-mobile"
        >
          <img src={Icontrash} alt="ico-ppl" height="12px" width="auto" style={{marginTop:"-4px"}} />{" "}
        </button>
        {errors.languageLevels && (
          <span className="error-msg">{errors.languageLevels}</span>
        )}
        <div className="dropdown-language-level-width language-level-mobile">
          <DropDownMultiCheck
            dataList={languageLevels}
            selecteds={searchObject.languageLevels}
            setSelecteds={setSelectedLanguageLevel}
          />
        </div>
      </div>
    </fieldset>
  );
}
